import DownloadIcon from "@mui/icons-material/Download";
import { Box, Button } from "@mui/material";
import { useTranslations } from "next-intl";
import { memo } from "react";

interface StatusPDFProps {
  dataDetailType?: number;
  handleOpen?: () => void;
  mode?: string;
}

const StatusPDF = (props: StatusPDFProps) => {
  const { dataDetailType, handleOpen, mode } = props;
  const t = useTranslations("messages");
  const handleScrollToReport = () => {
    const data = document.getElementById("report-container");
    data?.scrollIntoView({
      inline: "start",
      behavior: "smooth",
      block: "start",
    });
  };

  const handleScrollToInteractive = () => {
    const data = document.getElementById("powerbi-report-container");
    data?.scrollIntoView({
      inline: "start",
      behavior: "smooth",
      block: "start",
    });
  };

  const handleScrollToEmbed = () => {
    const data = document.getElementById("embed-report-container");
    data?.scrollIntoView({
      inline: "center",
      behavior: "smooth",
      block: "center",
    });
  };

  if (mode === "powerbi") {
    return (
      <Box>
        <Button
          className="!bg-cimigo-blue !text-white w-full !rounded !p-4 gap-2 !flex items-center justify-center hover:!bg-cimigo-blue-800 cursor-pointer view-report-button"
          onClick={() => handleScrollToInteractive()}
        >
          <Box className="py-1 gap-[10px] grid">
            <span
              className="font-medium text-base/6  normal-case"
              translation-key="common_view_report"
            >
              {t("common_view_interactive_dashboard")}
            </span>
          </Box>
        </Button>
      </Box>
    );
  }

  if (mode === "embed") {
    return (
      <Box>
        <Button
          className="!bg-cimigo-blue !text-white w-full !rounded !p-4 gap-2 !flex items-center justify-center hover:!bg-cimigo-blue-800 cursor-pointer view-report-button"
          onClick={() => handleScrollToEmbed()}
        >
          <Box className="py-1 gap-[10px] grid">
            <span
              className="font-medium text-base/6  normal-case"
              translation-key="common_view_embedded_report"
            >
              {t("common_view_embedded_report")}
            </span>
          </Box>
        </Button>
      </Box>
    );
  }

  switch (dataDetailType) {
    case 1:
      return (
        <Box className={"flex flex-col gap-3"}>
          <Box
            className="w-full  !no-underline hover:!underline !rounded !p-4 gap-2 !flex items-center justify-center  cursor-pointer !text-cimigoBlue"
            onClick={() => handleOpen?.()}
          >
            <Box className="h-6 w-6">
              <DownloadIcon />
            </Box>
            <Box className="py-1 gap-[10px] grid">
              <span
                className="font-medium text-base/6  normal-case"
                translation-key="common_download_now"
              >
                {t("common_download_now")}
              </span>
            </Box>
          </Box>
          <Button
            className="!bg-cimigo-blue !text-white w-full !rounded !p-4 gap-2 !flex items-center justify-center hover:!bg-cimigo-blue-800 cursor-pointer"
            onClick={() => handleScrollToReport()}
          >
            <Box className="py-1 gap-[10px] grid">
              <span
                className="font-medium text-base/6  normal-case"
                translation-key="common_view_report"
              >
                {t("common_view_report")}
              </span>
            </Box>
          </Button>
        </Box>
      );
    case 2: //mua lẻ
      return (
        <Box className={"flex flex-col gap-3"}>
          <Button
            variant="text"
            className="!bg-ciBlue_900 w-full !rounded !p-4 gap-2 !flex hover:!bg-cimigo_blue_light_1 get-full-access-button"
            onClick={() => handleOpen?.()}
          >
            <Box className="py-1 gap-[10px] grid">
              <span
                className="font-medium text-base/6 text-white normal-case"
                translation-key="common_get_full_access"
              >
                {t("common_get_full_access")}
              </span>
            </Box>
          </Button>
        </Box>
      );
    case 3: //mua nhiều
      return (
        <Box>
          <Button
            variant="text"
            className="!bg-ciBlue_900 w-full !rounded !p-4 gap-2 !flex hover:bg-cimigo_blue_light_1 go-to-report-button"
            onClick={() => handleOpen?.()}
          >
            <Box className="py-1 gap-[10px] grid">
              <span
                className="font-medium text-base/6 text-white normal-case"
                translation-key="common_get_full_access"
              >
                {t("common_get_full_access")}
              </span>
            </Box>
          </Button>
        </Box>
      );
    case  4:
      return (
        <Box className={"flex flex-col gap-3"}>
          <Box
            className="w-full  !no-underline hover:!underline !rounded !p-4 gap-2 !flex items-center justify-center  cursor-pointer !text-cimigoBlue"
            onClick={() => handleOpen?.()}
          >
            <Box className="h-6 w-6">
              <DownloadIcon />
            </Box>
            <Box className="py-1 gap-[10px] grid">
              <span
                className="font-medium text-base/6  normal-case"
                translation-key="common_download_now"
              >
                {t("common_download_now")}
              </span>
            </Box>
          </Box>
          <Button
            className="!bg-cimigo-blue !text-white w-full !rounded !p-4 gap-2 !flex items-center justify-center hover:!bg-cimigo-blue-800 cursor-pointer view-report-button"
            onClick={() => handleScrollToReport()}
          >
            <Box className="py-1 gap-[10px] grid">
              <span
                className="font-medium text-base/6  normal-case"
                translation-key="common_view_report"
              >
                {t("common_view_report")}
              </span>
            </Box>
          </Button>
        </Box>
      );
    default:
      return (
        <Box className={"flex flex-col gap-3"}>
          <Button
            className="!bg-cimigo-blue !text-white w-full !rounded !p-4 gap-2 !flex items-center justify-center hover:!bg-cimigo-blue-800 cursor-pointer view-report-button"
            onClick={() => handleScrollToReport()}
          >
            <Box className="py-1 gap-[10px] grid">
              <span
                className="font-medium text-base/6  normal-case"
                translation-key="common_view_report"
              >
                {t("common_view_report")}
              </span>
            </Box>
          </Button>
        </Box>
      );
  }
};

export default memo(StatusPDF);
